import { useState } from 'react';

function ImageUploader({ onImageUpload, isLoading }) {
  const [dragActive, setDragActive] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0] && !isLoading) {
      handleUpload(e.dataTransfer.files[0]);
    }
  };

  const handleUpload = (file) => {
    console.log('Uploaded file:', file);
    if (file && (file.type === 'image/jpeg' || file.type === 'image/png') && file.size <= 4 * 1024 * 1024) {
      setUploadedImage(file);
      onImageUpload(file);
    } else {
      onImageUpload(null, file.type !== 'image/jpeg' && file.type !== 'image/png' 
        ? 'Invalid file type (JPG/PNG only).' 
        : 'File size exceeded (Max 4MB).');
    }
  };

  return (
    <section className="w-full max-w-sm mb-3 bg-white p-3 rounded-lg shadow-sm h-48">
      <h3 className="text-md font-semibold text-center mb-2 text-gray-700">Upload Photo</h3>
      
      <label 
        htmlFor="fileUpload" 
        className={`block border border-dashed rounded-md p-2 text-center transition cursor-pointer h-32 overflow-hidden ${
          isLoading 
            ? 'opacity-60 cursor-not-allowed bg-gray-50' 
            : dragActive 
              ? 'bg-blue-50 border-blue-400' 
              : 'hover:bg-blue-50 border-gray-300'
        }`}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
      >
        <input
          type="file"
          accept="image/jpeg,image/png"
          onChange={(e) => e.target.files && handleUpload(e.target.files[0])}
          className="hidden"
          id="fileUpload"
          disabled={isLoading}
        />
        
        <div className="flex items-center justify-center gap-2">
          <div className="text-left">
            <p className="text-sm text-gray-800 font-medium">
              {dragActive ? "Drop image here" : "Drag & drop or click to upload"}
            </p>
            <p className="text-xs text-gray-600">Max 4MB</p>
          </div>
        </div>
        
        {uploadedImage && (
          <div className="mt-1.5 flex items-center justify-center">
            <img 
              src={URL.createObjectURL(uploadedImage)} 
              alt="Preview" 
              className="w-8 h-8 object-cover rounded-sm border border-gray-200"
            />
            <p className="ml-1.5 text-xs text-green-600 font-medium truncate max-w-[150px]">
              {uploadedImage.name}
            </p>
          </div>
        )}
      </label>
    </section>
  );
}

export default ImageUploader; 